import React from "react";
import { connect } from 'react-redux';
// import PointsMenu from "./PointsMenu";
// import EarnPointsForm from "./EarnPointsForm";
// import PointsRedemption from "./PointsRedemption";
// import OfferIncentives from "./OfferIncentives";
// import SelectLocations from "./SelectionLocations";
import ReportingBox from "../../components/ReportingBox";
import ReportTable from "../../components/ReportTable";
import LoadingModal from '../../components/LoadingModal'
import { getReportsList, getReports, emptyReports } from "../../modules/reports/ReportsActions";
import {
    Menu,
    Container,
    Dropdown,
    Header,
    Grid,
    Sidebar,
    Segment,
    Divider,
    Label,
    Icon
} from "semantic-ui-react";
import "./style.css";
import { isWindow } from "jquery";
var moment = require('moment');

const reports = [
    { key: 1, text: 'Sales Report by Product', value: 'Sales Report by Product', type: 'Transactional' },
    { key: 2, text: 'Employee Activity', value: 'Employee Activity', type: 'Transactional' },
    { key: 3, text: 'Inventory Snapshot', value: 'Inventory Snapshot', type: 'Snapshot - Location' },
    { key: 4, text: 'Product Details', value: 'Product Details', type: 'Current State' },
    { key: 5, text: 'Customer List', value: 'Customer List', type: 'Current State' },
    { key: 6, text: 'Purchase Orders Report', value: 'Purchase Orders Report', type: 'Transactional' },
    { key: 7, text: 'Sale Orders Report', value: 'Sale Orders Report', type: 'Transactional' },
    { key: 8, text: 'POS Orders Report', value: 'POS Orders Report', type: 'Transactional' },
]
// const dates = [
//     { key: 1, text: 'Today', value: 'Today' },
//     { key: 2, text: 'Yesterday', value: 'Yesterday' },
//     { key: 3, text: 'Last 7 Days', value: 'Last_7_Days' },
//     { key: 4, text: 'Last 30 Days', value: 'Last_30_Days' },
//     { key: 5, text: 'This Month', value: 'This_Month' },
//     { key: 6, text: 'Last Month', value: 'Last_Month' },
// ]
// const locations = [
//     { key: 1, text: 'Askari', value: 'Askari' },
//     { key: 2, text: 'Garrison', value: 'Garrison' },
//     { key: 3, text: 'GolfView', value: 'GolfView' },
//     { key: 4, text: 'Haider', value: 'Haider' },
//     { key: 5, text: 'Model', value: 'Model' },
//     { key: 6, text: 'MPS', value: 'MPS' },
//     { key: 7, text: 'badar', value: 'badar' },

// ]
const reportTypes = {
    'Sales Report by Product':
    {
        type: 'Transactional'
    },
    'Employee Activity': {
        type: 'Transactional'
    },
    'Inventory Snapshot': {
        type: 'Snapshot - Location'
    },
    'Product Details': {
        type: 'Current State'
    },
    'Customer List': {
        type: 'Current State'
    },
    'Purchase Orders Report': {
        type: 'Transactional'
    },
    'Sale Orders Report': {
        type: 'Transactional'
    },
    'POS Orders Report': {
        type: 'Transactional'
    }
}
class Reports extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            submitBtnLoader: false,
            loading: true,
            reportCurrentValue: null,
            reportType: null,
            dateCurrentValue: null,
            locationCurrentValue: null,
            datePickerEnabled: false,
            locationPickerEnabled: false,
            reports: [],
            dates: [],
            locations: [],
            showSearchPane: true,
            haveData: false,
            reportName: '',
            ranges: {
                'Today': [moment(), moment()],
                'Yesterday': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
                'Last 7 Days': [moment().subtract(7, 'days'), moment().subtract(1, 'days')],
                'Last 30 Days': [moment().subtract(30, 'days'), moment().subtract(1, 'days')],
                'This Month': [moment().startOf('month'), moment(), moment()],
                'Last Month': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')]
            },
            startDate: moment().subtract(1, 'days'),
            endDate: moment().subtract(1, 'days'),
        }
        this.handleReportChange = this.handleReportChange.bind(this);
        this.handleDateChange = this.handleDateChange.bind(this);
        this.handleLocationChange = this.handleLocationChange.bind(this);
        this.btnSubmit = this.btnSubmit.bind(this);
        this.handleSearchPane = this.handleSearchPane.bind(this)
        this.handleDatePicker = this.handleDatePicker.bind(this);
    }
    componentWillMount() {
        this.props.dispatch(emptyReports())
        this.props.dispatch(getReportsList()).then(res => {
            this.setState({ loading: false })
            var reports = res.data.reports;
            var dates = res.data.filters.dates;
            var locations = res.data.filters.locations;

            let tempReports = [];
            let tempDates = []
            let tempLocations = []

            var i = 0
            var key;
            for (key in reports) {
                let data = {
                    key: i,
                    text: key,
                    value: key,
                    type: reports[key]
                }
                tempReports.push(data)
                i++;
            }
            for (var i = 0; i < dates.length; i++) {
                let data = {
                    key: i,
                    text: dates[i].name,
                    value: dates[i].id,
                }
                tempDates.push(data)
            }
            // for (var i = 0; i < locations.length; i++) {
            //     let data = {
            //         key: i,
            //         text: locations[i].name,
            //         value: locations[i].id,
            //     }
            //     tempLocations.push(data)

            // }
            tempReports.sort(function (a, b) { return (a.text > b.text) ? 1 : ((b.text > a.text) ? -1 : 0); });

            if (tempReports.length) {

              for (var i = 0; i < tempReports[0]['type']['locations'].length; i++) {
                  let data = {
                      key: i,
                      text: tempReports[0]['type']['locations'][i],
                      value: tempReports[0]['type']['locations'][i],
                  }
                  tempLocations.push(data)
              }

              if (tempReports[0]['type']['aggregate_by_location']) {
                  tempLocations.push({
                      key: i,
                      text: 'All',
                      value: 'all',
                  })
              }
              if (tempReports[0]['type']['type'] === 'transactional') {
                  this.setState({
                      datePickerEnabled: false,
                      locationPickerEnabled: false,
                  })
              }
              else if (tempReports[0]['type']['type'] === 'current state') {
                  this.setState({
                      datePickerEnabled: true,
                      locationPickerEnabled: false,
                  })
              }
              else if (tempReports[0]['type']['type'] === 'snapshot by location') {
                  this.setState({
                      datePickerEnabled: true,
                      locationPickerEnabled: false,
                  })
              }
            }
            if (tempReports.length && tempDates.length && tempLocations.length) {
                this.setState({
                    haveData: true,
                    reportCurrentValue: tempReports[0].value,
                    reportType: tempReports[0].type,
                    dateCurrentValue: tempDates[0].value,
                    locationCurrentValue: tempLocations[0].value,
                    reports: tempReports,
                    dates: tempDates,
                    locations: tempLocations
                })
            }
        })
    }
    componentDidMount() {
        var d = document.getElementsByClassName('customScroll')
        d[0].style.height = (window.innerHeight - d[0].getClientRects()[0].top) + "px"
    }
    async btnSubmit() {
        // console.log('SUBMIT BTN CLICKED')
        let { startDate, endDate } = this.state;
        this.setState({ submitBtnLoader: true })
        let dateCurrentValue = {
            start_date: startDate.format('YYYY-MM-DD'),
            end_date: endDate.format('YYYY-MM-DD'),
        }
        // this.props.dispatch(getReports(this.state.dateCurrentValue, this.state.reportCurrentValue,
            // this.state.locationCurrentValue)
        // let res = await getReports(dateCurrentValue, this.state.reportCurrentValue, this.state.locationCurrentValue);
        // if (res.data.status) {
        //     this.setState({ submitBtnLoader: false });
        //     alert(res.data.status)
        //     window.location.href = res.data.link;
        //     return;
        // } else {
        //     if(res.headers["content-type"] === "text/csv") {
        //       this.setState({ submitBtnLoader: false });
        //       var data = new Blob([res.data], {type: 'text/csv'});
        //       var csvURL = window.URL.createObjectURL(data);
        //       var tempLink = document.createElement('a');
        //       console.log(tempLink)
        //       tempLink.href = csvURL;
        //       tempLink.setAttribute('download', this.state.reportCurrentValue + '.csv');
        //       tempLink.click();
        //       return;
        //     }

        //     if (res.data.data.length > 0) {
        //         this.setState({ submitBtnLoader: false, showSearchPane: false, reportName: this.state.reportCurrentValue })
        //     }
        //     else {
        //         this.setState({ submitBtnLoader: false, reportName: this.state.reportCurrentValue });
        //     }
        //     setTimeout(function () {
        //         var d = document.getElementsByClassName('customScroll')
        //         d[0].style.height = (window.innerHeight - d[0].getClientRects()[0].top - 16) + "px"
        //     }, 100);
        // }
        
        this.props.dispatch(getReports(dateCurrentValue, this.state.reportCurrentValue,
            this.state.locationCurrentValue)
        ).then(res => {
            if (res.data.status) {
                this.setState({ submitBtnLoader: false });
                alert(res.data.status)
                return;
            } else {
                if(res.headers["content-type"] === "text/csv") {
                  this.setState({ submitBtnLoader: false });
                  var data = new Blob([res.data], {type: 'text/csv'});
                  var csvURL = window.URL.createObjectURL(data);
                  var tempLink = document.createElement('a');
                  console.log(tempLink)
                  tempLink.href = csvURL;
                  tempLink.setAttribute('download', this.state.reportCurrentValue + '.csv');
                  tempLink.click();
                  return;
                }
            
            // if(res.headers["content-type"] === "text/csv") {
            //   this.setState({ submitBtnLoader: false });
            //   var data = new Blob([res.data], {type: 'text/csv'});
            //   var csvURL = window.URL.createObjectURL(data);
            //   var tempLink = document.createElement('a');
            //   console.log(tempLink)
            //   tempLink.href = csvURL;
            //   tempLink.setAttribute('download', this.state.reportCurrentValue + '.csv');
            //   tempLink.click();
            //   return;
            // }


            if (res.data.data.length > 0) {
                this.setState({ submitBtnLoader: false, showSearchPane: false, reportName: this.state.reportCurrentValue })
            }
            else {
                this.setState({ submitBtnLoader: false, reportName: this.state.reportCurrentValue });
            }
            setTimeout(function () {
                var d = document.getElementsByClassName('customScroll')
                d[0].style.height = (window.innerHeight - d[0].getClientRects()[0].top - 16) + "px"
            }, 100);
        }})
    
    
    }

    handleDatePicker(picker) {
        this.setState({
            startDate: picker.startDate,
            endDate: picker.endDate
        });
    }


    handleReportChange(value) {
        // console.log(value, 'value')
        var tempLocations = []
        this.setState({ reportCurrentValue: value }, () => {
            var reports = this.state.reports;

            var reportType = (val) => {
                var report = reports.find(report => {
                    return report.value === val
                })
                if (report) {
                    return report.type;
                } else {
                    return {};
                }
            }
            var reportLocations = () => {
                let tempLocations = []
                for (var i = 0; i < reportType(value).locations.length; i++) {
                    let data = {
                        key: i,
                        text: reportType(value).locations[i],
                        value: reportType(value).locations[i],
                    }
                    tempLocations.push(data)
                }
                if (reportType(value).aggregate_by_location) {
                    tempLocations.push({
                        key: i,
                        text: 'All',
                        value: 'all',
                    })
                }
                return tempLocations
            }

            if (reportType(value).type === 'transactional') {
                this.setState({
                    reportType: reportType(value).type,
                    datePickerEnabled: false,
                    locationPickerEnabled: false,
                    locations: reportLocations()
                })
            }
            else if (reportType(value).type === 'current state') {
                this.setState({
                    reportType: reportType(value).type,
                    datePickerEnabled: true,
                    locationPickerEnabled: false,
                    locations: reportLocations()
                })
            }
            else if (reportType(value).type === 'snapshot by location') {
                this.setState({
                    reportType: reportType(value).type,
                    datePickerEnabled: true,
                    locationPickerEnabled: false,
                    locations: reportLocations()
                })
            }
        })
    }

    handleDateChange(value) {
        // console.log(value, 'value')
        this.setState({ dateCurrentValue: value })
    }

    handleLocationChange(value) {
        // console.log(value, 'value')
        this.setState({ locationCurrentValue: value })
    }

    handleSearchPane() {
        this.setState({ showSearchPane: !this.state.showSearchPane })
        setTimeout(function () {
            var d = document.getElementsByClassName('customScroll')
            d[0].style.height = (window.innerHeight - d[0].getClientRects()[0].top - 16) + "px"
        }, 100);
    }

    render() {
        // return this.renderView();
        // console.log(this.props.reportList, '&&&&& report list')
        // console.log(this.props.reportData, '&&&&& report Data')
        // console.log(this.state, 'this.state')
        let rname = this.state.reportCurrentValue
        let locstr = this.state.locationCurrentValue
        if (locstr == 'all') locstr = "All Locations"
        let reportDownloadName = "Oscar - " + rname + " for " + locstr + ".csv"
        if (this.state.reportType == 'transactional') {
            let sdate = moment(this.state.startDate).add(1,'days').toISOString().slice(0,10)
            let edate = this.state.endDate.toISOString().slice(0,10)
            let datestr = (sdate == edate) ? sdate : (sdate + " to " + edate)
            reportDownloadName = "Oscar - " + rname + " for " + locstr + " (" + datestr + ").csv"
        }

        return (
            <div>
                <div style={styles.modal} className="ui center aligned grid">
                    <LoadingModal loading={this.state.loading} />
                </div>


                {this.state.showSearchPane ?
                    <div>
                        <Header style={styles.mainHeadig} as="h3">
                            REPORTS {this.state.haveData ? null : <div
                                style={{
                                    textAlign: 'center', color: '#9989E0',
                                    fontFamily: 'Roboto',
                                    fontWeight: 300,
                                    fontSize: 20
                                }}
                            >Please contact Oscar to have dashboard reporting activated for your domain</div>}
                        </Header>

                        <ReportingBox
                            showSearchPane={this.state.showSearchPane}
                            handleReportChange={this.handleReportChange}
                            handleDateChange={this.handleDateChange}
                            handleLocationChange={this.handleLocationChange}
                            btnSubmit={this.btnSubmit}
                            reports={this.state.reports}
                            dates={this.state.dates}
                            locations={this.state.locations}
                            reportCurrentValue={this.state.reportCurrentValue}
                            dateCurrentValue={this.state.dateCurrentValue}
                            locationCurrentValue={this.state.locationCurrentValue}
                            datePickerEnabled={this.state.datePickerEnabled}
                            locationPickerEnabled={this.state.locationPickerEnabled}
                            reportType={this.state.reportType}
                            submitBtnLoader={this.state.submitBtnLoader}
                            haveData={this.state.haveData}
                            ranges={this.state.ranges}
                            startDate={this.state.startDate}
                            endDate={this.state.endDate}
                            handleDatePicker={this.handleDatePicker}
                        />
                    </div>
                    : null}
                <ReportTable
                    reportName={this.state.reportName}
                    reportDownloadName={reportDownloadName}
                    showSearchPane={this.state.showSearchPane}
                    reportList={this.props.reportList}
                    reportData={this.props.reportData}
                    handleSearchPane={this.handleSearchPane} />
            </div>
        )
    }
}
const styles = {

    mainHeadig: {
        marginTop: 30,
        fontWeight: 400,
        fontFamily: "Roboto",
        color: "#666874"
    },
    modal: {
        flex: 1,
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        height: 160,
        position: 'absolute',
        top: 60,
        marginTop: 60,
    },

};
const mapStateToProps = state => {
    return {
        reportList: state.reports.reportList,
        reportData: state.reports.reportData,

    };
};
export default connect(mapStateToProps)(Reports);




// WEBPACK FOOTER //
// ./src/containers/Reports/index.js